<app-datatable
  data-automation-id="submitted-eforms-queue_202128102305"
  [columns]="columns"
  [dataUrl]="dataUrl"
  [defaultSort]="defaultSort"
  [scrollV]="false"
  [scrollH]="true"
  [actionTmpl]="actions"
  [preventInitialLoad]="true"
></app-datatable>

<ng-template #confirmationNumberTemplate let-row="row" let-value="value">
  <a
    *ngIf="row.filingSubmissionStatusId !== processingStatus && row.documentId"
    [routerLink]="[AppUrls.document.details(row.documentId)]"
    data-automation-id="submitted-eforms-queue_202127111221"
    target="_blank"
    class="link--open-new"
  >
    {{ value }}
    <mat-icon>open_in_new</mat-icon>
    <span class="sr-only">(Link opens in a new window)</span>
  </a>
  <strong
    *ngIf="row.filingSubmissionStatusId === processingStatus"
    data-automation-id="submitted-eforms-queue_202127111224"
  >
    {{ value }}
  </strong>
</ng-template>

<ng-template #associatedWithTemplate let-row="row" let-value="value">
  <ng-container
    *ngIf="
      row.relatedObjectId && row.relatedObjectTypeCode !== documentTypeCode.MedicalBillingDispute
    "
  >
    <a
      class="mat-button-link"
      data-automation-id="submitted-eforms-queue_202127111229"
      tabindex="0"
      [routerLink]="[AppUrls.detailsForSystemType(row.relatedObjectId, row.relatedObjectTypeCode)]"
    >
      {{ value }}
    </a>
  </ng-container>

  <ng-container
    *ngIf="
      row.relatedObjectId && row.relatedObjectTypeCode === documentTypeCode.MedicalBillingDispute
    "
  >
    <a class="mat-grey-bold-text" data-automation-id="submitted-eforms-queue_202127111233">
      {{ value }}
    </a>
  </ng-container>
</ng-template>

<ng-template #actions let-row="row">
  <mat-menu class="mat-simple-menu" #appMenu="matMenu">
    <button
      mat-menu-item
      (click)="printDocument(row)"
      data-automation-id="submitted-eforms-queue_202127111239"
    >
      Print
    </button>

    <button
      mat-menu-item
      (click)="downloadDocument(row)"
      data-automation-id="submitted-eforms-queue_202127111241"
    >
      Download
    </button>
  </mat-menu>

  <button
    *ngIf="row.documentId"
    mat-button
    class="mat-simple-button"
    color="primary"
    data-automation-id="submitted-eforms-queue_202127111244"
    [matMenuTriggerFor]="appMenu"
    aria-label="Open Row Actions Menu"
  >
    <mat-icon>list</mat-icon>
    Actions
  </button>
</ng-template>
